import { computed, onMounted, onUnmounted, unref } from 'vue'
import { message } from 'ant-design-vue'
import axios from 'axios'
import { useStore } from 'vuex'
import { useRoute, onBeforeRouteLeave, useRouter } from 'vue-router'
import { Modal } from 'ant-design-vue'
import { GlobalDataProps } from '@/store/index'
import { DEFAULT_COVER_IMAGE } from '@/utils/consts'
import { MaybeRef } from 'ant-design-vue/lib/_util/type'

// 在 Editor 中完成保存作品的一系列相关功能
function useSaveWork(disableSideEffects: MaybeRef<boolean> = false) {
  // 数据准备
  const route = useRoute()
  const router = useRouter()
  const currentWorkId = computed(() => route.params.id)
  const isCreatingMode = computed(() => currentWorkId.value === 'create')
  const store = useStore<GlobalDataProps>()
  const saveIsLoading = computed(() => store.getters.isOpLoading('saveWork'))
  const components = computed(() => store.state.editor.components)
  const page = computed(() => store.state.editor.page)
  const isDirty = computed(() => store.state.editor.isDirty)

  const createWork = async () => {
    const payload = {
      title: page.value.title || '作品标题',
      desc: page.value.desc || '作品描述',
      coverImg: page.value.coverImg || DEFAULT_COVER_IMAGE,
      content: {
        components: components.value,
        props: page.value.props,
        setting: page.value.setting
      }
    }
    const { data } = await axios('/works', {
      method: 'post',
      data: payload,
      opName: 'createWork'
    } as any)
    message.success('作品创建成功', 2)

    store.commit('fetchWork', { data: data.data })
    router.push({ name: 'EditorWork', params: { id: data.data.id } })
  }
  // 保存函数
  const saveWork = async (isManual = true) => {
    const { title, props, coverImg, desc, setting } = page.value
    const payload = {
      title,
      coverImg,
      desc,
      content: {
        components: components.value,
        props,
        setting
      }
    }
    await store.dispatch('saveWork', { data: payload, urlParams: { id: currentWorkId.value } })
    if (isManual) {
      message.success('作品更新成功', 2)
    }
  }
  if (!unref(disableSideEffects)) {
    // 自动保存
    let timer = 0
    onMounted(() => {
      timer = window.setInterval(() => {
        if (isDirty.value) {
          saveWork(false)
        }
      }, 1000 * 50)
    })
    onUnmounted(() => {
      clearInterval(timer)
    })
    // 离开路由前提示
    onBeforeRouteLeave((to, from, next) => {
      if (isDirty.value) {
        Modal.confirm({
          title: '作品还未保存，是否保存？',
          okText: '保存',
          okType: 'primary',
          cancelText: '不保存',
          onOk: async () => {
            await saveWork()
            next()
          },
          onCancel: () => {
            next()
          }
        })
      } else {
        next()
      }
    })
  }
  const handleSave = async () => {
    if (isCreatingMode.value) {
      createWork()
    } else {
      saveWork()
    }
  }
  return {
    createWork,
    saveWork,
    handleSave,
    saveIsLoading
  }
}
export default useSaveWork
